import { Reveal, Eyebrow } from "@/components/Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Do I have to purchase a large marketing package?",
    a: "No. You can begin with the $99.99 assessment or another standalone service appropriate to your needs.",
  },
  {
    q: "Does purchasing an assessment require me to hire All In Hand Marketing afterward?",
    a: "No. The assessment is intended to provide information and recommendations. Additional services are optional.",
  },
  {
    q: "Can you guarantee Google rankings, leads, revenue, or sales?",
    a: "No ethical marketing provider can guarantee a specific search ranking, number of leads, revenue amount, or business result. Performance depends on numerous factors outside any agency's control. We focus on agreed deliverables, sound marketing practices, measurement, testing, and continuous improvement.",
  },
  {
    q: "Can All In Hand Marketing work with an existing website?",
    a: "Yes. Existing websites, platforms, and marketing systems can be reviewed during discovery to determine compatibility and appropriate improvements.",
  },
  {
    q: "Do you provide AI and automation?",
    a: "Yes. Automation and AI-assisted workflows can be incorporated when they provide a practical business benefit and fit the project's technical requirements.",
  },
  {
    q: "Can you build custom software?",
    a: "Custom application, integration, and automation requirements can be evaluated and scoped as separate technology projects.",
  },
  {
    q: "Do you work with nonprofits?",
    a: "Yes. Services can be scoped for nonprofits, community organizations, and mission-driven initiatives as well as commercial businesses.",
  },
];

export const FAQ = ({ subset }) => {
  const items = subset ? subset.map((i) => FAQS[i]).filter(Boolean) : FAQS;
  return (
    <section id="faq" className="relative py-24 sm:py-32 bg-obsidian-900/50 border-y border-slate-800/60">
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <Reveal>
          <Eyebrow>Answers</Eyebrow>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white mt-4">
            Frequently Asked Questions
          </h2>
        </Reveal>

        <Reveal delay={0.1} className="mt-10">
          <Accordion type="single" collapsible className="w-full">
            {items.map((f, i) => (
              <AccordionItem key={f.q} value={`item-${i}`} className="border-slate-800">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i + 1}`}
                  className="font-display font-semibold text-white text-left text-base sm:text-lg hover:text-gold hover:no-underline py-5"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-300 leading-relaxed text-sm sm:text-base">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};

export default FAQ;
